<template>
    <div class="Summary">
        <div class="row">
            <div class="col col-md-4">
                <h4>Residence Info</h4>
                <p><span class="bold">Name: </span><span>{{ ResidenceData.Name }}</span></p>
                <p><span class="bold">License: </span><span>{{ ResidenceData.LicenseNumber }}</span></p>
                <p><span class="bold">Location: </span><span>{{ ResidenceData.Address.AddressSingleLine }}</span></p>
                <p><span class="bold">Phone: </span><span>{{ ResidenceData.PhoneNumber.FormattedPhoneNumber }}</span></p>
                <p><span class="bold">Program: </span><span>{{ ResidenceData.SubProgram.Name }}</span></p>
                <p><span class="bold">Occupancy: </span><span>{{ ResidenceData.CurrentOccupancyCapacityString }}</span></p>
            </div>
            <div class="col col-md-4">
                <h4>Current Clients</h4>
                <p v-for="crm in ResidenceData.ClientSubProgramResidenceMemberships">
                    {{ crm.ClientSubProgramMembership.Client.Person.FullName }} ({{ crm.ClientSubProgramMembership.Client.Person.AgeString }})
                </p>
            </div>
            <div class="col col-md-4">
                <h4>Staff on Shift</h4>
                <div v-for="ec in ResidenceData.EmployeeCheckins">
                    <p>
                        {{ ec.Employee.Person.FullName }}
                        <span v-if="EditMode && CheckPermission('CheckOutOthers') && ec.Employee.Id != User.PrivateProfile.EmployeeID">
                            <font-awesome-icon class="pointer" @click="ShowCheckOutModal(ec.Employee.Id,ResidenceData.Id,ec.Employee.Person.FullName,ResidenceData.Name)" :icon="['fa', 'door-open']" />
                        </span>
                        <br />({{ formatLocalDateTime(ec.CheckInDateTime) }})<br />
                        <span v-if="ec.Employee.Person.PhoneNumbers.length > 0">{{ ec.Employee.Person.PhoneNumbers[0].PhoneNumber.FormattedPhoneNumber }}</span>
                    </p>
                </div>
                <EmployeeCheckIn :residence-id="ResidenceData.Id" />
            </div>
            <!--<div class="col col-md-4">
            <h4>Staff On Shift</h4>
            <p><span class="bold">Regional Program: </span><span>{{ ChildRecordData.SubProgramName }}</span></p>
            <p><span class="bold">Placement Agency: </span><span>{{ ChildRecordData.PlacementAgencyName }} </span></p>
            <p><span class="bold">Start Date: </span><span>{{ formatDate(ChildRecordData.ClientProgramMembership.StartDate, 'MM/DD/YY') }}</span></p>
            <p><span class="bold">End Date: </span><span>{{ formatDate(ChildRecordData.ClientProgramMembership.EndDate, 'MM/DD/YY', 'Present') }}</span></p>
        </div>
        <div class="col col-md-4">
            <h4>Primary Therapist</h4>
            <div v-if="ChildRecordData.PrimaryTherapistName != null">
                <p><span class="bold">Name: </span><span>{{ ChildRecordData.PrimaryTherapistName }}</span></p>
            </div>
            <div v-else>
                <p><span class="bold">None Assigned </span><span></span></p>
            </div>
        </div>
        <div class="col col-md-4">
            <h4>School</h4>
            <p><span class="bold">{{ ChildRecordData.CurrentSchools }}</span></p>
        </div>-->
        </div>
        <EditMode Permission="CheckOutOthers" :EditMode="EditMode" @update-edit-mode="UpdateEditMode"/>
        <b-modal ref="toggle-modal" size="sm" :title="'Check Out ' + TargetEmployeeName + ' from ' + TargetResidenceName" hide-footer>
            <b-container>
                <b-row>
                    <div class="form-group">
                        <label>Check In Date:</label>
                        <flat-pickr class="form-control" :config="DateInputConfigSchema" v-model="TargetDate"></flat-pickr>
                    </div>
                    <div class="form-group">
                        <label>Check Out Time:</label>
                        <flat-pickr class="form-control" :config="TimeInputConfigSchema" v-model="TargetTime"></flat-pickr>
                    </div>
                </b-row>
                <b-row class="modal-btn-row">
                    <div class="modal-btn-row-div">
                        <b-button size="md" variant="secondary" @click="Cancel()">
                            CANCEL
                        </b-button>
                        <b-button size="md" variant="success" type="button" @click="SignOutOption">
                            CHECK Out
                        </b-button>
                    </div>

                </b-row>
            </b-container>
        </b-modal>
    </div>
</template>

<script>
    import EmployeeCheckIn from '../EmployeeCheckIn.vue';
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';
    import EditMode from '../../../Core/ItemEditors/EditMode.vue';
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faDoorOpen } from '@fortawesome/free-solid-svg-icons';
    library.add(faDoorOpen);
    import { EventBus } from '../../../../services/event-bus.js';
    export default {
        data: function () {
            return {
                User: {},
                TargetEmployeeName: "",
                TargetResidenceName: "",
                TargeEmployeeID: "",
                TargetResidenceID: "",
                EditMode: false,
                TargetDate: "",
                TargetTime: "",
                 DateInputConfigSchema: {
                    dateFormat: 'Y-m-d',
                    allowInput: true,
                    altInput: true,
                    altFormat: 'm/d/Y',
                },
                TimeInputConfigSchema: {
                    enableTime: true,
                    noCalendar: true,
                    dateFormat: 'H:i',
                    allowInput: true,
                    altInput: true,
                    altFormat: 'h:i K',
                    onChange: function (selectedDates, dateStr, instance) {
                        if (dateStr === '') { instance.close(); }
                    }
                }
            }
        },
        created() {
            let vm = this;
            EventBus.$on('update-check-in-status', payload => {
                if (payload.ResidenceID == vm.ResidenceId) {
                    vm.CheckedIn = payload.Status;
                }
            });
        },
        beforeDestroy() {
            EventBus.$off('update-check-in-status');
        },
        props: [
            'ResidenceData'
        ],
        methods: {
            SignOutOption() {
                console.log(this.TargetEmployeeID);
                this.$MasterAPI.ExecuteRequest("POST", "Residential/EmployeeCheckIn/CheckOutEmployee", { EmployeeID: this.TargetEmployeeID, ResidenceID: this.TargetResidenceID, TargetDateTime: this.combineTargetDateTimes() }, this.SignOutOptionSuccess, () => { }, true);
            },
            SignOutOptionSuccess(response) {
                EventBus.$emit('update-residence-list');
                EventBus.$emit('update-check-in-status', { Status: false, ResidenceID: this.ResidenceId });
                this.$refs["toggle-modal"].hide();
            },
            ShowCheckOutModal(EmployeeID,ResidenceID, EmployeeName,ResidenceName) {
                //moment().format("YYYY-MM-DD HH:mm");
                this.TargetDate = moment().format("YYYY-MM-DD");
                this.TargetTime = moment().format("HH:mm");
                this.ToggleModalTitle = this.CheckedIn ? "Check Out of House" : "Check In to House";
                this.TargetEmployeeID = EmployeeID;
                this.TargetResidenceID = ResidenceID;
                this.TargetEmployeeName = EmployeeName;
                this.TargetResidenceName = ResidenceName
                this.$refs["toggle-modal"].show();
            },
            combineTargetDateTimes() {
                let output = this.TargetDate + " " + this.TargetTime;
                console.log(output);
                return output;
            },
            CheckPermission(permissionName) {
                return this.$store.getters["User.PrivateProfile.CheckPermission"](permissionName);
            },
            formatDate(value, fmt = 'MM/DD/YY', defaultText = '') {
                return (value == null)
                    ? defaultText
                    : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            formatLocalDateTime(value, fmt = 'MMM Do h:mm A') {
                return (value == null)
                    ? ''
                    : moment.utc(value, 'YYYY-MM-DD HH:mm:ss').format(fmt)
            },
            Cancel() {
                this.$refs["toggle-modal"].hide();
            },
            UpdateEditMode() {
                this.EditMode = !this.EditMode;
            }
        },
        components: {
            EmployeeCheckIn,
            flatPickr,
            EditMode
        },
        mounted() {
             this.User = this.$store.state.User;
        },
        computed: {
            SubProgramFormMemberships: function () {
                let subProgram = this.$store.getters["User.PrivateProfile.SubPrograms.GetSubProgram"](this.ResidenceData.SubProgramID);
                return subProgram.FormMemberships.filter(fm => fm.ChartType == "Residence");
            }
        },
    }
</script>

<style scoped>
</style>